import { IPatientSurveyWithAnswers } from "../../../../@types/admin/AdminPatient";
import { getLongFormattedDate } from "../../../../utils/dateFormatter";
import {
  ModalContainer,
  ModalHeader,
  ModalSubtitle,
  ModalTitle,
} from "../AdminPage.styles";
import {
  PanelStack,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from "./PatientDetailsPanel.styles";

interface IPatientSurveyAnswersModalProps {
  survey: IPatientSurveyWithAnswers;
}

/**
 * One completed survey's questions and answers (EN-5170) — the drill-down
 * behind `modulePatientSurveys`' "View answers" row action.
 *
 * The answers arrive with the row (`questionsAnswers` on
 * `PatientSurveyWithAnswers`), so opening this needs no request — which is why
 * the button is disabled rather than loading when a survey has none.
 */
export function PatientSurveyAnswersModal({
  survey,
}: IPatientSurveyAnswersModalProps) {
  const answers = survey.questionsAnswers ?? [];

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle>{survey.surveyName || "Survey answers"}</ModalTitle>
        <ModalSubtitle>
          Completed{" "}
          {getLongFormattedDate(survey.lastCompletedDate, "at an unknown time")}
          {survey.lastTotalScore !== null && survey.lastTotalScore !== undefined
            ? ` · total score ${survey.lastTotalScore}`
            : ""}
        </ModalSubtitle>
      </ModalHeader>

      {answers.length === 0 ? (
        <SummaryValue>This survey has no recorded answers.</SummaryValue>
      ) : (
        <PanelStack>
          {answers.map((entry, index) => (
            <SummaryItem key={`${entry.question ?? "question"}-${index}`}>
              <SummaryLabel>{entry.question || "Question"}</SummaryLabel>
              <SummaryValue>{entry.answer || "No answer"}</SummaryValue>
            </SummaryItem>
          ))}
        </PanelStack>
      )}
    </ModalContainer>
  );
}
